import type { ReactElement } from 'react'
import {
  AccountBalanceWallet,
  BeachAccess,
  Campaign,
  ChatBubbleOutline,
  Event,
  PersonAdd,
  Speed,
} from '@mui/icons-material'

type NotificationIconFactory = () => ReactElement

const iconFactories: Record<string, NotificationIconFactory> = {
  'lesson.start_soon': () => <Event fontSize="small" />,
  'lesson.started': () => <Event fontSize="small" />,
  'chat.message.created': () => <ChatBubbleOutline fontSize="small" />,
  'vacation.teacher': () => <BeachAccess fontSize="small" />,
  'vacation.student': () => <BeachAccess fontSize="small" />,
  'invitation.student_registered': () => <PersonAdd fontSize="small" />,
  'placement.completed': () => <Speed fontSize="small" />,
  'placement.invited': () => <Speed fontSize="small" />,
}

export function registerNotificationIcon(
  eventKey: string,
  factory: NotificationIconFactory,
): void {
  iconFactories[eventKey] = factory
}

export function notificationIcon(eventKey: string): ReactElement {
  if (eventKey.startsWith('billing.') || eventKey.startsWith('platform.')) {
    return <AccountBalanceWallet fontSize="small" />
  }
  return (iconFactories[eventKey] ?? (() => <Campaign fontSize="small" />))()
}

/** Same-origin SPA path only; rejects protocol-relative `//…`. */
export function safeInternalNotificationUrl(url: string | null | undefined): string | null {
  if (!url || !url.startsWith('/') || url.startsWith('//')) {
    return null
  }
  return url
}
